export default {
  permissionDenied:
    'We need permission to record your video and audio. Click the security status icon in your Chrome browser’s address bar and allow access to proceed.',
  smart_capture: {
    title: 'Record your interactions',
    description:
      'You can later add voiceovers, edit and publish to <b>%{workspace_name}</b>',
    placeholder: 'Start by presenting your screen.',
    placeholder_install_ext:
      'Start creating your new video by installing the extension.',
    install_extension: 'Install Chrome Extension to Proceed',
    share_and_record: 'Share screen and record',
    note: {
      tag: 'ALL-NEW',
      title:
        'Just present your screen. Trainn’s smart capture will do the rest.',
      description:
        'Useful for creating product walkthrough videos, or product demos.'
    }
  },
  screen: {
    title: 'Record your screen',
    description: 'Cast your screen and record instantly.',
    placeholder: 'Present your screen to start recording.',
    share_and_record: 'Share screen and record',
    header_title: 'Select your voice and automation preferences'
  },
  webcam: {
    title: 'Record yourself',
    description: 'Camera is on. Don’t forget to smile. :)',
    placeholder: 'Switch on your camera',
    start_recording: 'Start Recording'
  },
  stream_file: {
    title: 'Record over a PDF',
    description: 'Present your PDF and start recording.',
    placeholder:
      'Upload your presentation and record a video while navigating through the slides.',
    upload_pdf: 'Upload PDF',
    start_recording: 'Start Recording'
  },
  file: {
    title: 'Upload and edit',
    description: 'Upload & edit files on your device.',
    placeholder: 'Drag and drop files here',
    open_my_files: 'Or open my files…',
    upload_file: 'Upload Files...',
    note: 'Formats supported: .mp4, .mov, .jpeg, .png, .pdf',
    upload_and_edit: 'Upload and edit',
    proceed: 'Proceed',
    trimAndProceed: 'Trim and proceed',
    recent_files: {
      title: 'Choose file…',
      description:
        'You can import images, PDFs, or snippets from videos from your recent files or local storage.',
      empty: 'No recent files',
      video: 'Video',
      image: 'Image'
    }
  },
  clips_selector: {
    title: 'Create Clips and Use in Your Video',
    description:
      'Choose to add snippets by specifying start and end time from the chosen video.',
    optional: '(optional)',
    make_clips: 'Create Clips and Use in Your Video',
    start_time: 'Start time',
    end_time: 'End time',
    add_snippet: 'Add snippet',
    upload_and_edit: 'Upload and Edit'
  },
  start: 'Start Recording',
  pause: 'Pause',
  resume: 'Resume',
  cancel: 'Cancel',
  stop: 'Finish Recording',
  status: {
    recording_in_progress: 'Recording',
    recording_paused: 'Recording paused',
    starting: 'Starting your recording…',
    starting_guidance: 'Please wait while we get everything ready.',
    browser_title_starting: 'Starting…',
    browser_title: '%{remaining} left · Recording',
    browser_title_paused: '%{remaining} left · Paused',
    browser_title_warning: '%{remaining} left · Recording',
    browser_title_finishing: 'Finishing…',
    finishing: 'Finishing your recording…',
    sharing_status: 'You’re currently sharing the tab you selected.',
    sharing_guidance:
      'Return here anytime to pause or finish recording.',
    max_recording_length: 'Maximum recording length: 5 minutes',
    limit_warning: 'Less than 1 minute remaining.'
  },
  last_updated: 'Last updated:',
  submit_video: 'Submit Video',
  publish_preview_video: 'Preview and Publish',
  audio_generating: 'Generating audio... \n Please wait :)',
  publish_video: 'Publish Video',
  exit_preview: 'Exit preview',
  uploading_in_progress:
    'Hang tight! We are uploading your recording. This might take a few seconds.',
  camera_off: "Someone's too shy. <br /> Alright, someother time :)",
  max_upload_size: 'Maximum Upload Size: %{size}MB',
  onboarding: {
    title: 'Before you hit record',
    tip: 'Tip',
    of: 'of',
    tip_1_title: 'Record Casually',
    tip_1:
      "Record like you're explaining a workflow on a live call.<br/><br/>Don't worry about making mistakes. Lara rectifies them, and you can always make changes later.<br/><br/><strong>Bonus:</strong> Turn on Zooms and Spotlights for the best output.",
    tip_2_title: 'Record browser or full screen',
    tip_2:
      'For web apps select <strong>Chrome Tab</strong>.<br/>For desktop apps select <strong>Entire Screen</strong>.<br/><br/>Wait for the countdown, then start. Click <strong>Stop Sharing</strong> to generate the video.',
    tip_3_title: 'Best to keep under 5 mins',
    tip_3:
      'We recommend recording <strong>under 5 minutes</strong> for the best output.<br/><br/>You can always record more once the video is generated.',
    next_tip: 'Next Tip',
    finish: 'Finish & Start Recording'
  },
  recording_blocked:
    "You've reached your content creation limit. Please upgrade or contact support.",
  mode_selector: {
    title: 'How would you like to start?',
    popular: 'Most popular',
    manual_divider: 'Or',
    agent: {
      title: 'Create with Lara',
      beta: 'BETA',
      description:
        'Meet Lara, the video creation agent that turns your raw recording into a polished training video, on its own.',
      start: 'Start',
      limit_reached:
        'You have reached your limit. Contact support to learn more.'
    },
    options: {
      screen: {
        title: 'Record my screen',
        description:
          'Capture a walkthrough of your product directly from your browser.'
      },
      screen_and_cam: {
        title: 'Screen and webcam',
        description: 'Record your screen with your webcam overlaid on top.'
      },
      webcam: {
        title: 'Cam only',
        description: 'Record yourself using just your webcam.'
      },
      stream_file: {
        title: 'Present over PDF',
        description: 'Narrate your slides while presenting a PDF.'
      },
      upload: {
        title: 'Upload a video & edit',
        description: 'Drop in a video file from your computer to start editing.'
      }
    }
  },
  agent_setup: {
    header_title: 'Create with Trainn AI Agent',
    switch_to_default: 'Switch to default',
    start_here: 'Input Source',
    intro_title: 'Introducing Lara',
    intro_desc:
      "Lara does everything you'd do yourself. Give it a recording, it writes the narration, makes the edits, and hands you back a structured training video, ready to share.",
    intro_learn_more: 'Learn more.',
    intro_learn_more_url: 'https://help.trainn.co/share/uIorQK1SIP5pCPauQhcoXg',
    narration_heading: 'Select a Voiceover Mode',
    narration_subtitle: 'Pick who creates the voiceover for your video.',
    lara_narrate: {
      title: 'Generate AI Voiceover',
      description:
        'Record your screen. The agent writes the script and generates the AI voiceover automatically.'
    },
    own_narration: {
      title: 'Turn Narration to AI Voiceover',
      description:
        'Converts your narration into an AI voiceover. Rewrites mistakes, strips fillers, and removes background noise.'
    },
    microphone_label: 'Microphone',
    desktop_client_label: 'Record using desktop client',
    settings: 'Agent Controls',
    voice: 'Voice',
    language: 'Language',
    convert_to_ai_voice: 'Use My Voice',
    smart_edits: 'Smart Edits',
    auto_spotlight: 'Auto Spotlight',
    auto_spotlight_tooltip:
      "The agent highlights each click so viewers don't miss important click actions.",
    auto_zoom: 'Auto Zoom',
    start_recording: 'Start Recording',
    record: {
      title: 'Record my screen',
      subtitle: 'You record, Agent edits'
    },
    upload: {
      title: 'Upload a video',
      subtitle: 'You upload, Agent edits'
    },
    upload_heading: 'Transform Recordings into Product Videos',
    upload_subtitle:
      "Upload any screen recording. Trainn's agent adds AI voiceovers, and visual effects automatically.",
    drop_title: 'Drag & drop your video here',
    browse_hint: 'MP4 · up to 5 minutes',
    choose_file: 'Choose File',
    upload_button: 'Upload and let Agent edit',
    uploading: 'Uploading your video…',
    invalid_type: 'Unsupported file. Please upload an MP4 video.'
  },
  agentic_mode: {
    title: 'Agentic Mode',
    beta: 'BETA',
    description_off:
      'Classic recording — Trainn auto-adds spotlights, zooms and narration as you go.',
    description_on:
      'Hand it off to the agent — it edits, narrates and polishes the final cut for you.',
    off: 'Off',
    on: 'On',
    editing_in_progress_title: 'Agent takes 5 - 7 minutes to edit your video.',
    editing_in_progress_link_text: "Here's why →",
    editing_in_progress_subtitle:
      "Your video will appear here when Lara's done.",
    editing_less_than_minute: 'Started less than a minute ago',
    editing_runtime: 'About %{minutes} min elapsed',
    limit_reached:
      "You've reached your Agentic Mode video limit. Please upgrade or contact support."
  }
};
